// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client'
import type {
  GetRootData,
  GetRootResponses,
  GetSystemOverviewData,
  GetSystemOverviewResponses,
  GetSystemLogsData,
  GetSystemLogsResponses,
  GetControlUnitLogsData,
  GetControlUnitLogsResponses,
  DownloadControlUnitLogFileData,
  DownloadControlUnitLogFileResponses,
  StartControlUnitData,
  StartControlUnitResponses,
  StopControlUnitData,
  StopControlUnitResponses,
} from './types.gen'
import { client as _heyApiClient } from './@tanstack/initializer'

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Service description
 * Returns the service name and the list of available endpoints.
 */
export const getRoot = <ThrowOnError extends boolean = false>(options?: Options<GetRootData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetRootResponses, unknown, ThrowOnError>({
    url: '/',
    ...options,
  })
}

/**
 * Aggregated system health overview
 * Evaluates all system predicates (services, network, hardware, storage, temperatures) and aggregates their results. Predicate results are cached per predicate; predicates whose dependencies fail are reported as skipped.
 */
export const getSystemOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetSystemOverviewData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetSystemOverviewResponses, unknown, ThrowOnError>({
    url: '/system-overview',
    ...options,
  })
}

/**
 * Tail of the full systemd journal
 * Last 250 lines of journalctl --no-pager (all units including kernel).
 */
export const getSystemLogs = <ThrowOnError extends boolean = false>(
  options?: Options<GetSystemLogsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetSystemLogsResponses, unknown, ThrowOnError>({
    url: '/logs/system',
    ...options,
  })
}

/**
 * Tail of citysense-control-unit journal
 * Last 250 lines of journalctl -u citysense-control-unit --no-pager.
 */
export const getControlUnitLogs = <ThrowOnError extends boolean = false>(
  options?: Options<GetControlUnitLogsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<GetControlUnitLogsResponses, unknown, ThrowOnError>({
    url: '/logs/control-unit',
    ...options,
  })
}

/**
 * Download the newest control unit log file
 * Streams the newest file under log.directory as an attachment. Returns an empty body when no log directory or file is found.
 */
export const downloadControlUnitLogFile = <ThrowOnError extends boolean = false>(
  options?: Options<DownloadControlUnitLogFileData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<DownloadControlUnitLogFileResponses, unknown, ThrowOnError>({
    url: '/logs/control-unit-files',
    ...options,
  })
}

/**
 * Start control unit service
 * Starts the citysense-control-unit systemd unit.
 */
export const startControlUnit = <ThrowOnError extends boolean = false>(
  options?: Options<StartControlUnitData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<StartControlUnitResponses, unknown, ThrowOnError>({
    url: '/start-control-unit',
    ...options,
  })
}

/**
 * Stop control unit service
 * Stops the citysense-control-unit systemd unit.
 */
export const stopControlUnit = <ThrowOnError extends boolean = false>(
  options?: Options<StopControlUnitData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<StopControlUnitResponses, unknown, ThrowOnError>({
    url: '/stop-control-unit',
    ...options,
  })
}
